import { useEffect, useState } from 'react';

import Toggle from '@/components/common/Toggle/Toggle';
import Spinner from '@/components/common/Spinner/Spinner';
import styles from './reason-codes-table.module.scss';
import { useGetUserRole } from '@/hooks/identity/useGetUserRole';
import { UserRole } from '@/config/roles.config';

interface IReasonCodesTableProps {
  rows: ReasonCode[];
  onAddNewReasonName: Function;
  onToggleReasonName: (code: ReasonCode['code'], enable: boolean, type: string) => void;
  isLoading?: boolean;
  reasonType: ReasonType;
}

export default function ReasonCodesTable({
  rows,
  onAddNewReasonName,
  onToggleReasonName,
  isLoading,
  reasonType
}: IReasonCodesTableProps) {

  const { getUserRole } = useGetUserRole();
  const [userRole, setUserRole] = useState<UserRole>();

  useEffect(() => {
    const getInitialData = async () => {
      const roleName = await getUserRole();
      setUserRole(roleName);
    };

    getInitialData();
  }, [getUserRole]);

  return (
    <>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.code}>Reason Code</th>
            <th
              className={styles.name}
              colSpan={2}
            >
              {userRole === UserRole.FULL_ACCESS && (
                <div className="d-flex justify-content-between align-items-center">
                  Reason Name
                  <a
                    className={styles.link}
                    data-testid="add-new-link"
                    onClick={() => onAddNewReasonName()}
                  >
                    Add Reason Name
                  </a>
                </div>
              )}
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((el) => (
            <tr key={el.code}>
              <td className={styles.code} data-testid="code">{el.code}</td>
              <td className={styles.name} data-testid="name">{el.name}</td>
              <td className={styles.toggle}>
                <Toggle
                  id={el.code}
                  testId="toggle"
                  isEnable={el.enabled}
                  disabled={(userRole !== UserRole.FULL_ACCESS)}
                  onChange={() => onToggleReasonName(el.code, !el.enabled, reasonType.type)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {!isLoading && Array.isArray(rows) && rows.length === 0 && (
        <div className="d-flex justify-content-center mt-40 mb-30">
          There are no reason codes yet
        </div>
      )}

      {isLoading && (
        <div className="d-flex justify-content-center mt-50 mb-50">
          <Spinner />
        </div>
      )}
    </>
  );
}
